import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { getRarityColor } from '@sorare/core/src/lib/colors';

export const BottomGlow = ({ rarity }: { rarity: Rarity }) => (
  <svg
    width="564"
    height="48"
    viewBox="0 0 564 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.2" filter="url(#filter0_f_16123_45858)">
      <ellipse
        cx="282"
        cy="50"
        rx="254"
        ry="22"
        fill={getRarityColor(rarity)}
      />
    </g>
    <defs>
      <filter
        id="filter0_f_16123_45858"
        x="0"
        y="0"
        width="564"
        height="100"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="14"
          result="effect1_foregroundBlur_16123_45858"
        />
      </filter>
    </defs>
  </svg>
);
